import { render } from "./index.vue?vue&type=template&id=47b43f9e&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=47b43f9e&lang=sass&scoped=true"

import exportComponent from "/spug/spug_api/repos/119_10566_20260928180206/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b43f9e"],['__file',"src/views/space-division/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47b43f9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47b43f9e', __exports__)) {
    console.log('reload')
    api.reload('47b43f9e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=47b43f9e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('47b43f9e', render)
  })

}


export default __exports__